// App.js
import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithCustomToken, signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import {
  getFirestore,
  collection,
  addDoc,
  onSnapshot,
  doc,
  updateDoc,
  deleteDoc,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { useReactToPrint } from 'react-to-print';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import html2pdf from 'html2pdf.js';

// --- Config Firebase (igual que en tu archivo) ---
const firebaseConfig = {
  apiKey: "AIzaSyAllk0B-JbKdCedDa8KTBfB0Dhm07CaSt0",
  authDomain: "presupuesto-97d4b.firebaseapp.com",
  projectId: "presupuesto-97d4b",
  storageBucket: "presupuesto-97d4b.firebasestorage.app",
  messagingSenderId: "970810128701",
  appId: "1:970810128701:web:d072f7984522ffaa0e6d54",
  measurementId: "G-025B6YZ0W9"
};

const appId = "1:970810128701:web:d072f7984522ffaa0e6d54";
const initialAuthToken = null;

const companyDetails = {
  name: 'TALLER MOVIL MENORCA S.C.',
  nif: 'J22436109',
  address: 'Of. Adm.: Carrer Pere Cortes 29 1-1',
  postcode_city: '07760 Ciutadella',
  province: 'Illes Balears',
  phone: '(34) 691 599 985',
  email: 'tallermovilmenorca@gmail.com'
};

const logoBase64 = "https://tallermovilmenorca.com/img/logo/logotaller.png";

// --- Componente principal ---
export default function App() {
  // --- LOGIN STATE ---
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginUser, setLoginUser] = useState('');
  const [loginPass, setLoginPass] = useState('');
  const [loginError, setLoginError] = useState('');

  // --- APP STATES (siempre definidos, aunque no se usen hasta que haya login) ---
  const [db, setDb] = useState(null);
  const [auth, setAuth] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isAuthReady, setIsAuthReady] = useState(false);

  const [budgets, setBudgets] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [clients, setClients] = useState([]);
  const [articles, setArticles] = useState([]);

  const [activeTab, setActiveTab] = useState('budgets');
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState('budget');
  const [editingDocId, setEditingDocId] = useState(null);
  const [editingClientId, setEditingClientId] = useState(null);
  const [editingArticleId, setEditingArticleId] = useState(null);

  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [docToDelete, setDocToDelete] = useState(null);

  const [showPreview, setShowPreview] = useState(false);
  const [previewDoc, setPreviewDoc] = useState(null);
  const [previewType, setPreviewType] = useState('budget');
  const componentRef = useRef();
  const handlePrint = useReactToPrint({content: () => componentRef.current,});
  
  const handleExportPDF = () => {
	  if (!previewDoc) return;
	  const element = componentRef.current;
	  const opt = {
		margin:       0.5,
		filename:     `${previewDoc.title || 'documento'}.pdf`,
		image:        { type: 'jpeg', quality: 0.98 },
		html2canvas:  { scale: 2 },
		jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
	  };
	  html2pdf().set(opt).from(element).save();
  };

  const [createFromDocItemId, setCreateFromDocItemId] = useState(null);

  const emptyDocForm = {
    clientId: '',
    vehicleId: '',
    date: new Date().toISOString().slice(0, 10),
    items: [{ id: uuidv4(), articleId: '', reference: '', description: '', quantity: 1, unitPrice: 0 }],
    ivaRate: 21,
    notes: '',
    paymentMethod: '',
  };
  const [docFormState, setDocFormState] = useState(emptyDocForm);

  const emptyClientForm = {
    name: '',
    surname: '',
    dni: '',
    phone: '',
    address: '',
    city: '',
    province: '',
    vehicles: [{ id: uuidv4(), registration: '', brand: '', model: '', year: '', km: '', vin: '' }]
  };
  const [clientFormState, setClientFormState] = useState(emptyClientForm);

  const [articleFormState, setArticleFormState] = useState({
    reference: '', description: '', unitPrice: 0
  });

  const [articleSearch, setArticleSearch] = useState('');
  const [articleSort, setArticleSort] = useState({ field: 'description', dir: 'asc' });

  // --- FIREBASE INIT ---
  useEffect(() => {
    const init = async () => {
      try {
        const app = initializeApp(firebaseConfig);
        const authInstance = getAuth(app);
        const dbInstance = getFirestore(app);
        setAuth(authInstance);
        setDb(dbInstance);

        const unsubAuth = onAuthStateChanged(authInstance, async (user) => {
          if (user) {
            setUserId(user.uid);
            setIsAuthReady(true);
            setLoading(false);
          } else {
            try {
              if (initialAuthToken) await signInWithCustomToken(authInstance, initialAuthToken);
              else await signInAnonymously(authInstance);
            } catch (err) {
              console.error('Auth error', err);
              setError('Error al iniciar sesión en Firebase.');
              setLoading(false);
            }
          }
        });
        return () => unsubAuth();
      } catch (err) {
        console.error('Init Firebase', err);
        setError('Error inicializando Firebase.');
        setLoading(false);
      }
    };
    if (!db) init();
  }, [db]);

  // --- HANDLERS LOGIN ---
  const handleLogin = (e) => {
    e.preventDefault();
    if (loginUser === 'ALEXDP' && loginPass === 'Pil@r&2010') {
      setIsLoggedIn(true);
      setLoginError('');
    } else {
      setLoginError('Usuario o contraseña incorrectos.');
    }
  };
  
  
// --- LISTENERS REALTIME ---
	useEffect(() => {
	  if (!isAuthReady || !db || !userId) return;

	  const budgetsRef = collection(db, `artifacts/${appId}/users/${userId}/budgets`);
	  const invoicesRef = collection(db, `artifacts/${appId}/users/${userId}/invoices`);
	  const clientsRef = collection(db, `artifacts/${appId}/users/${userId}/clients`);
	  const articlesRef = collection(db, `artifacts/${appId}/users/${userId}/articles`);

	  const unsubBudgets = onSnapshot(budgetsRef, (snap) =>
		setBudgets(snap.docs.map(d => ({ id: d.id, ...d.data() })))
	  );

	  const unsubInvoices = onSnapshot(invoicesRef, (snap) =>
		setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })))
	  );

	  const unsubClients = onSnapshot(clientsRef, (snap) => {
		const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
		setClients(
		  data.sort((a, b) => {
			if (!a.name) return 1;
			if (!b.name) return -1;
			return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
		  })
		);
	  });

	  const unsubArticles = onSnapshot(articlesRef, (snap) => {
		const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
		setArticles(
		  data.sort((a, b) => {
			if (!a.reference) return 1;
			if (!b.reference) return -1;
			return a.reference.localeCompare(b.reference, undefined, { numeric: true });
		  })
		);
	  });

	  return () => {
		unsubBudgets();
		unsubInvoices();
		unsubClients();
		unsubArticles();
	  };
	}, [db, userId, isAuthReady]);


  // --- Utilities ---
  const showMsg = (txt) => {
    setMessage(txt);
    setTimeout(() => setMessage(''), 3500);
  };

  const calculateSubtotal = (items) => items.reduce((s, it) => s + (Number(it.quantity || 0) * Number(it.unitPrice || 0)), 0);
  const calculateIva = (subtotal, ivaRate) => subtotal * (ivaRate / 100);
  const calculateTotal = (subtotal, iva) => subtotal + iva;

  const generateDocumentTitle = (type, documents) => {
    const prefix = type === 'budget' ? 'PRESUP' : 'FACT';
    const date = new Date();
    const year = String(date.getFullYear()).slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, '0');

    const docsInMonth = (documents || []).filter(d => {
      const docDate = new Date(d.date);
      return docDate.getFullYear() === date.getFullYear() && docDate.getMonth() === date.getMonth();
    });

    docsInMonth.sort((a, b) => {
      const numA = parseInt(a.title?.split('-').pop() || '0', 10) || 0;
      const numB = parseInt(b.title?.split('-').pop() || '0', 10) || 0;
      return numB - numA;
    });

    const lastNumber = docsInMonth[0] ? (parseInt(docsInMonth[0].title.split('-').pop(), 10) || 0) : 0;
    const next = String(lastNumber + 1).padStart(3, '0');
    return `${prefix} ${year}-${month}-${next}`;
  };

  // --- CRUD Documentos ---
  const handleDocFormChange = (e) => {
    const { name, value } = e.target;
    setDocFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleDocItemChange = (itemId, field, value) => {
    setDocFormState(prev => ({
      ...prev,
      items: prev.items.map(it => it.id === itemId ? { ...it, [field]: value } : it)
    }));
  };

  const handleAddDocItem = () => {
    setDocFormState(prev => ({ ...prev, items: [...prev.items, { id: uuidv4(), articleId: '', reference: '', description: '', quantity: 1, unitPrice: 0 }] }));
  };

  const handleRemoveDocItem = (itemId) => {
    setDocFormState(prev => ({ ...prev, items: prev.items.filter(i => i.id !== itemId) }));
  };

  const handleSelectArticleForItem = (itemId, articleId) => {
    const art = articles.find(a => a.id === articleId);
    if (!art) return;
    setDocFormState(prev => ({
      ...prev,
      items: prev.items.map(i => i.id === itemId ? {
        ...i,
        articleId: art.id,
        reference: art.reference,
        description: art.description,
        unitPrice: Number(art.unitPrice)
      } : i)
    }));
  };

  const handleOpenCreateArticleFromItem = (itemId) => {
    setCreateFromDocItemId(itemId);
    setArticleFormState({
      reference: '',
      description: '',
      unitPrice: 0
    });
    setEditingArticleId(null);
    setFormType('article');
    setShowForm(true);
  };

  const handleSubmitDocument = async (e) => {
    e && e.preventDefault();
    if (!isAuthReady) return showMsg('Autenticación no completa.');

    setLoading(true);
    try {
      const collectionName = formType === 'budget' ? 'budgets' : 'invoices';
      const documents = formType === 'budget' ? budgets : invoices;

      const subtotal = calculateSubtotal(docFormState.items);
      const ivaAmount = calculateIva(subtotal, docFormState.ivaRate);
      const total = calculateTotal(subtotal, ivaAmount);

      const selectedClient = clients.find(c => c.id === docFormState.clientId);
      const selectedVehicle = selectedClient?.vehicles?.find(v => v.id === docFormState.vehicleId);

      const docData = {
        ...docFormState,
        title: generateDocumentTitle(formType, documents),
        clientName: selectedClient ? `${selectedClient.name} ${selectedClient.surname}` : '',
        clientData: selectedClient ? {
          address: selectedClient.address,
          city: selectedClient.city,
          province: selectedClient.province,
          phone: selectedClient.phone,
          dni: selectedClient.dni
        } : {},
        vehicleData: selectedVehicle ? {
          registration: selectedVehicle.registration,
          brand: selectedVehicle.brand,
          model: selectedVehicle.model,
          km: selectedVehicle.km,
          vin: selectedVehicle.vin
        } : {},
        items: docFormState.items.map(it => ({
          id: it.id,
          articleId: it.articleId || '',
          reference: it.reference,
          description: it.description,
          quantity: Number(it.quantity),
          unitPrice: Number(it.unitPrice),
          total: Number((Number(it.quantity) * Number(it.unitPrice)).toFixed(2))
        })),
        subtotal: Number(subtotal.toFixed(2)),
        ivaAmount: Number(ivaAmount.toFixed(2)),
        total: Number(total.toFixed(2)),
        createdAt: new Date().toISOString(),
        isConverted: false
      };

      if (editingDocId) {
        const docRef = doc(db, `artifacts/${appId}/users/${userId}/${collectionName}`, editingDocId);
        await updateDoc(docRef, docData);
        showMsg('Documento actualizado correctamente.');
      } else {
        await addDoc(collection(db, `artifacts/${appId}/users/${userId}/${collectionName}`), docData);
        showMsg('Documento creado correctamente.');
      }

      // Reset
      setDocFormState(emptyDocForm);
      setEditingDocId(null);
      setShowForm(false);
      setCreateFromDocItemId(null);
    } catch (err) {
      console.error('Submit doc error', err);
      showMsg('Error guardando documento.');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenEditDocument = (docItem, type) => {
    setEditingDocId(docItem.id);
    setFormType(type === 'budget' || type === 'budgets' ? 'budget' : 'invoice');
    setDocFormState({
      clientId: docItem.clientId || '',
      vehicleId: docItem.vehicleId || '',
      date: docItem.date || new Date().toISOString().slice(0, 10),
      items: (docItem.items && docItem.items.length) ? docItem.items.map(i => ({ ...i, id: i.id || uuidv4() })) : [{ id: uuidv4(), articleId: '', reference: '', description: '', quantity: 1, unitPrice: 0 }],
      ivaRate: docItem.ivaRate || 21,
      notes: docItem.notes || '',
      paymentMethod: docItem.paymentMethod || ''
    });
    setShowForm(true);
  };

  const handleDeleteDocumentConfirm = (id, type) => {
    setDocToDelete({ id, type });
    setShowDeleteModal(true);
  };


// Convert budget -> invoice
// Convertir presupuesto a factura
	const handleConvertToInvoice = async (budget) => {
	  if (!isAuthReady) return showMsg('Autenticación no completa.');
	  setLoading(true);

	  try {
		// Buscar el cliente y vehículo asociados para copiar toda la información
		const selectedClient = clients.find(c => c.id === budget.clientId);
		const selectedVehicle = selectedClient?.vehicles?.find(v => v.id === budget.vehicleId);

		const newInvoice = {
		  // Campos esenciales
		  userId: userId,
		  title: generateDocumentTitle('invoice', invoices),
		  date: new Date().toISOString().slice(0, 10),
		  createdAt: new Date().toISOString(),
		  isConverted: false,
		  
		  // Datos del cliente y vehículo
		  clientId: budget.clientId,
		  clientName: budget.clientName || (selectedClient ? `${selectedClient.name} ${selectedClient.surname}` : ''),
		  clientData: selectedClient ? {
			address: selectedClient.address,
			city: selectedClient.city,
			province: selectedClient.province,
			phone: selectedClient.phone,
			dni: selectedClient.dni
		  } : {},
		  vehicleId: budget.vehicleId || '',
		  vehicleData: selectedVehicle ? {
			registration: selectedVehicle.registration,
			brand: selectedVehicle.brand,
			model: selectedVehicle.model,
			km: selectedVehicle.km,
			vin: selectedVehicle.vin
		  } : {},

		  // Artículos y totales
		  items: budget.items || [],
		  ivaRate: budget.ivaRate || 21,
		  subtotal: budget.subtotal || 0,
		  ivaAmount: budget.ivaAmount || 0,
		  total: budget.total || 0,

		  // Otros campos
		  notes: budget.notes || '',
		  paymentMethod: budget.paymentMethod || '',
		};

		// Guardar factura en Firestore
		await addDoc(collection(db, `artifacts/${appId}/users/${userId}/invoices`), newInvoice);

		// Marcar presupuesto como convertido
		const budgetRef = doc(db, `artifacts/${appId}/users/${userId}/budgets`, budget.id);
		await updateDoc(budgetRef, { isConverted: true });

		showMsg('Presupuesto convertido a factura.');
		setActiveTab('invoices');
	  } catch (err) {
		console.error('Convert error', err);
		showMsg('Error convirtiendo presupuesto.');
	  } finally {
		setLoading(false);
	  }
	};

  // --- CRUD Clientes ---
  const handleClientChange = (e) => {
    const { name, value } = e.target;
    setClientFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleVehicleChange = (vehicleId, field, value) => {
    setClientFormState(prev => ({ ...prev, vehicles: prev.vehicles.map(v => v.id === vehicleId ? { ...v, [field]: value } : v) }));
  };

  const handleAddVehicle = () => {
    setClientFormState(prev => ({ ...prev, vehicles: [...prev.vehicles, { id: uuidv4(), registration: '', brand: '', model: '', year: '', km: '', vin: '' }] }));
  };

  const handleRemoveVehicle = (vehicleId) => {
    setClientFormState(prev => ({ ...prev, vehicles: prev.vehicles.filter(v => v.id !== vehicleId) }));
  };

  const handleSubmitClient = async (e) => {
    e && e.preventDefault();
    if (!isAuthReady) return showMsg('Autenticación no completa.');
    setLoading(true);
    try {
      if (editingClientId) {
        const clientRef = doc(db, `artifacts/${appId}/users/${userId}/clients`, editingClientId);
        await updateDoc(clientRef, clientFormState);
        showMsg('Cliente actualizado.');
      } else {
        await addDoc(collection(db, `artifacts/${appId}/users/${userId}/clients`), clientFormState);
        showMsg('Cliente creado.');
      }
      setClientFormState(emptyClientForm);
      setEditingClientId(null);
      setShowForm(false);
    } catch (err) {
      console.error('Client save error', err);
      showMsg('Error guardando cliente.');
    } finally {
      setLoading(false);
    }
  };

  const handleEditClient = (client) => {
    setEditingClientId(client.id);
    setClientFormState({
      name: client.name || '',
      surname: client.surname || '',
      dni: client.dni || '',
      phone: client.phone || '',
      address: client.address || '',
      city: client.city || '',
      province: client.province || '',
      vehicles: (client.vehicles && client.vehicles.length) ? client.vehicles : [{ id: uuidv4(), registration: '', brand: '', model: '', year: '', km: '', vin: '' }]
    });
    setFormType('client');
    setShowForm(true);
  };

  const handleAskDeleteClient = (client) => {
    setDocToDelete({ id: client.id, type: 'client' });
    setShowDeleteModal(true);
  };

  // --- CRUD Articles ---
  const handleArticleChange = (e) => {
    const { name, value } = e.target;
    setArticleFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmitArticle = async (e) => {
    e && e.preventDefault();
    if (!isAuthReady) return showMsg('Autenticación no completa.');
    setLoading(true);
    try {
      const referenceTrim = (articleFormState.reference || '').trim();
      if (!referenceTrim) {
        showMsg('Referencia obligatoria.');
        setLoading(false);
        return;
      }
      // Unique reference check (excluding self if editing)
      const exists = articles.find(a => a.reference === referenceTrim && a.id !== editingArticleId);
      if (exists) {
        showMsg('La referencia ya existe. Debe ser única.');
        setLoading(false);
        return;
      }

      if (editingArticleId) {
        const artRef = doc(db, `artifacts/${appId}/users/${userId}/articles`, editingArticleId);
        await updateDoc(artRef, { reference: referenceTrim, description: articleFormState.description, unitPrice: Number(articleFormState.unitPrice) });
        showMsg('Artículo actualizado.');
      } else {
        const newArtRef = await addDoc(collection(db, `artifacts/${appId}/users/${userId}/articles`), {
          reference: referenceTrim,
          description: articleFormState.description,
          unitPrice: Number(articleFormState.unitPrice)
        });
        showMsg('Artículo creado.');
        // If creation initiated from a doc item, associate it automatically
        if (createFromDocItemId) {
          // fetch created article to get its id and fields
          // We assume real-time listener will update articles; find by reference
          const created = articles.find(a => a.reference === referenceTrim) || null;
          if (created) {
            // apply immediately
            setDocFormState(prev => ({
              ...prev,
              items: prev.items.map(it => it.id === createFromDocItemId ? {
                ...it,
                articleId: created.id,
                reference: created.reference,
                description: created.description,
                unitPrice: Number(created.unitPrice)
              } : it)
            }));
          } else {
            // fallback: after small delay, try to assign using a getDocs query
            setTimeout(async () => {
              try {
                const q = query(collection(db, `artifacts/${appId}/users/${userId}/articles`), where('reference', '==', referenceTrim));
                const qsnap = await getDocs(q);
                const foundDoc = qsnap.docs[0];
                if (foundDoc) {
                  const found = { id: foundDoc.id, ...foundDoc.data() };
                  setDocFormState(prev => ({
                    ...prev,
                    items: prev.items.map(it => it.id === createFromDocItemId ? {
                      ...it,
                      articleId: found.id,
                      reference: found.reference,
                      description: found.description,
                      unitPrice: Number(found.unitPrice)
                    } : it)
                  }));
                }
              } catch (err) {
                console.error('Assign created article fallback', err);
              }
            }, 600);
          }
        }
      }

      setArticleFormState({ reference: '', description: '', unitPrice: 0 });
      setEditingArticleId(null);
      setCreateFromDocItemId(null);
      setShowForm(false);
    } catch (err) {
      console.error('Article save error', err);
      showMsg('Error guardando artículo.');
    } finally {
      setLoading(false);
    }
  };

  const handleEditArticle = (article) => {
    setEditingArticleId(article.id);
    setArticleFormState({
      reference: article.reference || '',
      description: article.description || '',
      unitPrice: article.unitPrice || 0
    });
    setFormType('article');
    setShowForm(true);
  };

  const handleAskDeleteArticle = (article) => {
    setDocToDelete({ id: article.id, type: 'article' });
    setShowDeleteModal(true);
  };

	 // --- Generic delete ---
	const handleDeleteGeneric = async () => {
	  if (!isAuthReady || !docToDelete) return showMsg('Operación no permitida.');
		
		// Almacena el documento en una variable local para evitar que se pierda con el re-render
		const docToDeleteLocal = { ...docToDelete };
		
		// Reinicia el estado inmediatamente para evitar re-renders y dobles llamados
		setShowDeleteModal(false);
		setDocToDelete(null);

		setLoading(true);

		try {
		  const { id, type } = docToDeleteLocal;
		  let collectionName = '';
		  if (type === 'budget' || type === 'budgets') collectionName = 'budgets';
		  else if (type === 'invoice' || type === 'invoices') collectionName = 'invoices';
		  else if (type === 'client' || type === 'clients') collectionName = 'clients';
		  else if (type === 'article' || type === 'articles') collectionName = 'articles';
		  if (!collectionName) throw new Error('Tipo no soportado');

		  const ref = doc(db, `artifacts/${appId}/users/${userId}/${collectionName}`, id);
		  console.log('ID de usuario en el estado:', userId);
		  console.log('Intentando eliminar de la colección:', collectionName, 'con ID:', id);
		  
		  await deleteDoc(ref);
		  showMsg('Eliminado correctamente.');
		} catch (err) {
		  console.error('Delete generic', err);
		  showMsg('Error eliminando.');
		} finally {
		  setLoading(false);
	  }
	};

  // --- Preview / Print ---
  const openPreview = (docItem, type) => {
    setPreviewDoc(docItem);
    setPreviewType(type === 'budget' ? 'budget' : 'invoice');
    setShowPreview(true);
  };

  const closePreview = () => {
    setShowPreview(false);
    setPreviewDoc(null);
    setPreviewType('budget');
  };

  // --- Articles table filter/sort derived list ---
  const filteredArticles = articles
    .filter(a => {
      const term = articleSearch.trim().toLowerCase();
      if (!term) return true;
      return (a.description || '').toLowerCase().includes(term) ||
        (a.reference || '').toLowerCase().includes(term) ||
        String(a.unitPrice || '').toLowerCase().includes(term);
    })
    .sort((a, b) => {
      const field = articleSort.field;
      const dir = articleSort.dir === 'asc' ? 1 : -1;
      const va = (a[field] || '').toString().toLowerCase();
      const vb = (b[field] || '').toString().toLowerCase();
      if (va < vb) return -1 * dir;
      if (va > vb) return 1 * dir;
      return 0;
    });

  const toggleArticleSort = (field) => {
    setArticleSort(prev => (prev.field === field ? { field, dir: prev.dir === 'asc' ? 'desc' : 'asc' } : { field, dir: 'asc' }));
  };

  // --- UI helpers ---
  const handleOpenNewDoc = (type) => {
    setFormType(type);
    setShowForm(true);
    setEditingDocId(null);
    setDocFormState(emptyDocForm);
  };

  const handleOpenNewClient = () => {
    setFormType('client');
    setShowForm(true);
    setEditingClientId(null);
    setClientFormState(emptyClientForm);
  };

  const handleOpenNewArticle = () => {
    setFormType('article');
    setShowForm(true);
    setEditingArticleId(null);
    setArticleFormState({ reference: '', description: '', unitPrice: 0 });
    setCreateFromDocItemId(null);
  };

  // --- Render forms / content ---
  const renderDocForm = () => {
    const docTitle = formType === 'budget' ? 'Presupuesto' : 'Factura';
    const selectedClient = clients.find(c => c.id === docFormState.clientId);
    return (
      <div className="container py-4">
        <div className="card shadow rounded-4 border-0">
          <div className="card-header d-flex justify-content-between align-items-center p-4">
            <h5 className="mb-0">{editingDocId ? `Editar ${docTitle}` : `Nuevo ${docTitle}`}</h5>
            <div>
              <button className="btn btn-outline-secondary me-2" onClick={() => { setShowForm(false); setEditingDocId(null); setCreateFromDocItemId(null); }}><i className="bi-x-lg"></i></button>
            </div>
          </div>
          <div className="card-body p-4">
            <form onSubmit={handleSubmitDocument}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Cliente</label>
                  <select className="form-select" name="clientId" value={docFormState.clientId} onChange={handleDocFormChange} required>
                    <option value="">Selecciona un cliente</option>
                    {clients.map(c => <option key={c.id} value={c.id}>{c.name} {c.surname}</option>)}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="form-label">Fecha</label>
                  <input className="form-control" type="date" name="date" value={docFormState.date} onChange={handleDocFormChange} required />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Método de pago</label>
                  <select className="form-select" name="paymentMethod" value={docFormState.paymentMethod} onChange={handleDocFormChange}>
                    <option value="">Selecciona</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Tarjeta">Tarjeta</option>
                    <option value="Transferencia">Transferencia Bancaria</option>
                  </select>
                </div>

                {selectedClient && (
                  <div className="col-12">
                    <label className="form-label">Vehículo</label>
                    <select className="form-select" name="vehicleId" value={docFormState.vehicleId} onChange={handleDocFormChange}>
                      <option value="">Sin vehículo</option>
                      {(selectedClient.vehicles || []).map(v => <option key={v.id} value={v.id}>{v.brand} {v.model} ({v.registration})</option>)}
                    </select>
                  </div>
                )}

                <div className="col-12">
                  <label className="form-label">Artículos / Servicios</label>
                  {docFormState.items.map((item, idx) => (
                    <div key={item.id} className="row g-2 align-items-center mb-2">
                      <div className="col-md-4">
                        <select className="form-select" value={item.articleId || ''} onChange={(e) => {
                          const val = e.target.value;
                          if (val === '__create__') handleOpenCreateArticleFromItem(item.id);
                          else handleSelectArticleForItem(item.id, val);
                        }}>
                          <option value="">-- Buscar artículo (o Crear nuevo) --</option>
                          {articles.map(a => <option key={a.id} value={a.id}>{a.reference} — {a.description} ({Number(a.unitPrice).toFixed(2)}€)</option>)}
                          <option value="__create__">+ Crear nuevo artículo</option>
                        </select>
                      </div>

                      <div className="col-md-4">
                        <input className="form-control" type="text" placeholder="Descripción" value={item.description} onChange={(e) => handleDocItemChange(item.id, 'description', e.target.value)} required />
                      </div>

                      <div className="col-md-1">
                        <input className="form-control text-end" type="number" min="0" step="1" value={item.quantity} onChange={(e) => handleDocItemChange(item.id, 'quantity', e.target.value)} required />
                      </div>

                      <div className="col-md-2">
                        <input className="form-control text-end" type="number" min="0" step="0.01" value={item.unitPrice} onChange={(e) => handleDocItemChange(item.id, 'unitPrice', e.target.value)} required />
                      </div>

                      <div className="col-md-1 d-flex justify-content-end">
                        <div className="text-end">
                          <div className="fw-bold">{(Number(item.quantity) * Number(item.unitPrice)).toFixed(2)} €</div>
                          {docFormState.items.length > 1 && <button type="button" className="btn btn-sm btn-link text-danger" onClick={() => handleRemoveDocItem(item.id)}><i className="bi-trash"></i></button>}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="mt-2">
                    <button type="button" className="btn btn-sm btn-secondary" onClick={handleAddDocItem}><i className="bi-plus-circle me-2"></i>Añadir artículo</button>
                  </div>
                </div>

                <div className="col-12 mt-3">
                  <label className="form-label">Notas</label>
                  <textarea className="form-control" name="notes" value={docFormState.notes} onChange={handleDocFormChange} rows={3} placeholder="Notas del presupuesto / factura (aparecerán en la impresión)"></textarea>
                </div>

                <div className="col-12 text-end mt-3">
                  <p className="mb-1">Subtotal: <strong>{calculateSubtotal(docFormState.items).toFixed(2)} €</strong></p>
                  <p className="mb-1">IVA ({docFormState.ivaRate}%): <strong>{calculateIva(calculateSubtotal(docFormState.items), docFormState.ivaRate).toFixed(2)} €</strong></p>
                  <p className="h5 fw-bold text-primary">Total: {calculateTotal(calculateSubtotal(docFormState.items), calculateIva(calculateSubtotal(docFormState.items), docFormState.ivaRate)).toFixed(2)} €</p>
                </div>

                <div className="col-12">
                  <div className="d-flex gap-2">
                    <button type="submit" className="btn btn-primary">{editingDocId ? 'Actualizar' : 'Guardar'} {docTitle}</button>
                    <button type="button" className="btn btn-outline-secondary" onClick={() => {
                      // Quick preview without saving
                      const previewData = {
                        ...docFormState,
                        title: generateDocumentTitle(formType, formType === 'budget' ? budgets : invoices),
                        subtotal: calculateSubtotal(docFormState.items),
                        ivaAmount: calculateIva(calculateSubtotal(docFormState.items), docFormState.ivaRate),
                        total: calculateTotal(calculateSubtotal(docFormState.items), calculateIva(calculateSubtotal(docFormState.items), docFormState.ivaRate))
                      };
                      setPreviewDoc(previewData);
                      setPreviewType(formType === 'budget' ? 'budget' : 'invoice');
                      setShowPreview(true);
                    }}>Previsualizar</button>
                    <button type="button" className="btn btn-outline-danger ms-auto" onClick={() => { setShowForm(false); setDocFormState(emptyDocForm); }}>Cancelar</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };

  //const handleOpenCreateArticleFromItem = (itemId) => {
  //  setCreateFromDocItemId(itemId);
  //  handleOpenNewArticle();
  //};

  const renderClientForm = () => (
    <div className="container py-4">
      <div className="card shadow rounded-4 border-0">
        <div className="card-header d-flex justify-content-between align-items-center p-4">
          <h5 className="mb-0">{editingClientId ? 'Editar Cliente' : 'Nuevo Cliente'}</h5>
          <div>
            <button className="btn btn-outline-secondary me-2" onClick={() => { setShowForm(false); setEditingClientId(null); }}><i className="bi-x-lg"></i></button>
          </div>
        </div>
        <div className="card-body p-4">
          <form onSubmit={handleSubmitClient}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Nombre</label>
                <input className="form-control" name="name" value={clientFormState.name} onChange={handleClientChange} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">Apellidos</label>
                <input className="form-control" name="surname" value={clientFormState.surname} onChange={handleClientChange} required />
              </div>
              <div className="col-md-6">
                <label className="form-label">DNI</label>
                <input className="form-control" name="dni" value={clientFormState.dni} onChange={handleClientChange} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Teléfono</label>
                <input className="form-control" name="phone" value={clientFormState.phone} onChange={handleClientChange} />
              </div>
              <div className="col-12">
                <label className="form-label">Dirección</label>
                <input className="form-control" name="address" value={clientFormState.address} onChange={handleClientChange} />
              </div>

              <div className="col-12">
                <hr />
                <h6>Vehículos</h6>
                {(clientFormState.vehicles || []).map(v => (
                  <div key={v.id} className="card p-3 mb-2 bg-light">
                    <div className="row g-2">
                      <div className="col-md-4"><input className="form-control" placeholder="Matrícula" value={v.registration} onChange={(e) => handleVehicleChange(v.id, 'registration', e.target.value)} /></div>
                      <div className="col-md-4"><input className="form-control" placeholder="Marca" value={v.brand} onChange={(e) => handleVehicleChange(v.id, 'brand', e.target.value)} /></div>
                      <div className="col-md-4"><input className="form-control" placeholder="Modelo" value={v.model} onChange={(e) => handleVehicleChange(v.id, 'model', e.target.value)} /></div>
                      <div className="col-md-3 mt-2"><input className="form-control" placeholder="Año" value={v.year} onChange={(e) => handleVehicleChange(v.id, 'year', e.target.value)} /></div>
                      <div className="col-md-3 mt-2"><input className="form-control" placeholder="Km" value={v.km} onChange={(e) => handleVehicleChange(v.id, 'km', e.target.value)} /></div>
                      <div className="col-md-6 mt-2"><input className="form-control" placeholder="VIN" value={v.vin} onChange={(e) => handleVehicleChange(v.id, 'vin', e.target.value)} /></div>
                    </div>
                    {clientFormState.vehicles.length > 1 && <div className="mt-2"><button type="button" className="btn btn-sm btn-danger" onClick={() => handleRemoveVehicle(v.id)}>Eliminar vehículo</button></div>}
                  </div>
                ))}
                <button type="button" className="btn btn-sm btn-secondary mt-2" onClick={handleAddVehicle}><i className="bi-plus-circle me-2"></i>Añadir vehículo</button>
              </div>

              <div className="col-12">
                <div className="d-flex gap-2 mt-3">
                  <button className="btn btn-primary" type="submit">{editingClientId ? 'Actualizar' : 'Guardar'}</button>
                  <button type="button" className="btn btn-outline-danger" onClick={() => { setShowForm(false); setClientFormState(emptyClientForm); }}>Cancelar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  const renderArticleForm = () => (
    <div className="container py-4">
      <div className="card shadow rounded-4 border-0">
        <div className="card-header d-flex justify-content-between align-items-center p-4">
          <h5 className="mb-0">{editingArticleId ? 'Editar Artículo' : 'Nuevo Artículo'}</h5>
          <div><button className="btn btn-outline-secondary" onClick={() => { setShowForm(false); setEditingArticleId(null); setCreateFromDocItemId(null); }}><i className="bi-x-lg"></i></button></div>
        </div>
        <div className="card-body p-4">
          <form onSubmit={handleSubmitArticle}>
            <div className="mb-3">
              <label className="form-label">Referencia</label>
              <input name="reference" className="form-control" value={articleFormState.reference} onChange={handleArticleChange} required />
            </div>
            <div className="mb-3">
              <label className="form-label">Descripción</label>
              <textarea name="description" className="form-control" value={articleFormState.description} onChange={handleArticleChange} required />
            </div>
            <div className="mb-3">
              <label className="form-label">Precio unitario</label>
              <input name="unitPrice" type="number" step="0.01" className="form-control" value={articleFormState.unitPrice} onChange={handleArticleChange} required />
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-primary" type="submit">{editingArticleId ? 'Actualizar' : 'Guardar'}</button>
              <button type="button" className="btn btn-outline-danger" onClick={() => { setShowForm(false); setEditingArticleId(null); setCreateFromDocItemId(null); }}>Cancelar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  // --- Main content per tab ---
  const renderContent = () => {
    if (loading) return <div className="d-flex justify-content-center align-items-center p-4" style={{ height: '60vh' }}><div className="spinner-border text-primary" /></div>;
    if (error) return <div className="alert alert-danger m-4">{error}</div>;

    if (activeTab === 'budgets') {
      return (
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Presupuestos</h5>
            <div><button className="btn btn-primary" onClick={() => handleOpenNewDoc('budget')}><i className="bi-plus-circle me-2"></i>Nuevo Presupuesto</button></div>
          </div>
          {budgets.length === 0 ? <div className="alert alert-info">No hay presupuestos.</div> : (
            <div className="row g-3">
              {budgets.map(b => (
                <div key={b.id} className="col-12">
                  <div className="card p-3 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-1">{b.title}</h6>
                        <div className="small text-muted">Cliente: {b.clientName} • Fecha: {b.date}</div>
                        <div className="small text-muted">Total: {b.total} €</div>
                      </div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => handleOpenEditDocument(b, 'budget')} title="Editar"><i className="bi-pencil"></i></button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteDocumentConfirm(b.id, 'budget')} title="Eliminar"><i className="bi-trash"></i></button>
                        {!b.isConverted && (
                          <>
                            <button className="btn btn-sm btn-outline-success" onClick={async () => await handleConvertToInvoice(b)} title="Convertir"><i className="bi-receipt"></i></button>
                            <button className="btn btn-sm btn-outline-primary" onClick={() => openPreview(b, 'budget')} title="Ver / Imprimir"><i className="bi-printer"></i></button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    if (activeTab === 'invoices') {
      return (
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Facturas</h5>
            <div><button className="btn btn-primary" onClick={() => handleOpenNewDoc('invoice')}><i className="bi-plus-circle me-2"></i>Nueva Factura</button></div>
          </div>
          {invoices.length === 0 ? <div className="alert alert-info">No hay facturas.</div> : (
            <div className="row g-3">
              {invoices.map(f => (
                <div key={f.id} className="col-12">
                  <div className="card p-3 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-1">{f.title}</h6>
                        <div className="small text-muted">Cliente: {f.clientName} • Fecha: {f.date}</div>
                        <div className="small text-muted">Total: {f.total} €</div>
                      </div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => handleOpenEditDocument(f, 'invoice')} title="Editar"><i className="bi-pencil"></i></button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteDocumentConfirm(f.id, 'invoice')} title="Eliminar"><i className="bi-trash"></i></button>
						<button className="btn btn-sm btn-outline-primary" onClick={() => openPreview(f, 'invoice')} title="Ver / Imprimir"><i className="bi-printer"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    if (activeTab === 'clients') {
      return (
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Clientes</h5>
            <div><button className="btn btn-primary" onClick={handleOpenNewClient}><i className="bi-plus-circle me-2"></i>Nuevo Cliente</button></div>
          </div>
          {clients.length === 0 ? <div className="alert alert-info">No hay clientes.</div> : (
            <div className="row g-3">
              {clients.map(c => (
                <div key={c.id} className="col-12">
                  <div className="card p-3 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-1">{c.name} {c.surname}</h6>
                        <div className="small text-muted">DNI: {c.dni} • Tel: {c.phone}</div>
                      </div>
                      <div className="d-flex gap-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={() => handleEditClient(c)} title="Editar"><i className="bi-pencil"></i></button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleAskDeleteClient(c)} title="Eliminar"><i className="bi-trash"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    if (activeTab === 'articles') {
      return (
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>Artículos</h5>
            <div className="d-flex gap-2">
              <input className="form-control form-control-sm" style={{ maxWidth: 300 }} placeholder="Buscar..." value={articleSearch} onChange={(e) => setArticleSearch(e.target.value)} />
              <button className="btn btn-primary" onClick={handleOpenNewArticle}><i className="bi-plus-circle me-2"></i>Nuevo Artículo</button>
            </div>
          </div>

          {filteredArticles.length === 0 ? <div className="alert alert-info">No hay artículos que coincidan.</div> : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: 'pointer' }} onClick={() => toggleArticleSort('reference')}>Referencia {articleSort.field === 'reference' ? (articleSort.dir === 'asc' ? '▲' : '▼') : ''}</th>
                    <th style={{ cursor: 'pointer' }} onClick={() => toggleArticleSort('description')}>Descripción {articleSort.field === 'description' ? (articleSort.dir === 'asc' ? '▲' : '▼') : ''}</th>
                    <th style={{ cursor: 'pointer' }} onClick={() => toggleArticleSort('unitPrice')}>Precio {articleSort.field === 'unitPrice' ? (articleSort.dir === 'asc' ? '▲' : '▼') : ''}</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredArticles.map(a => (
                    <tr key={a.id}>
                      <td>{a.reference}</td>
                      <td>{a.description}</td>
                      <td>{Number(a.unitPrice).toFixed(2)} €</td>
                      <td>
                        <div className="d-flex gap-2">
                          <button className="btn btn-sm btn-outline-secondary" onClick={() => handleEditArticle(a)}><i className="bi-pencil"></i></button>
                          <button className="btn btn-sm btn-outline-danger" onClick={() => handleAskDeleteArticle(a)}><i className="bi-trash"></i></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    }

    return null;
  };

  // --- Preview modal with embedded styles and RGPD footer + payment details ---
  const renderPreviewModal = () => {
    if (!showPreview || !previewDoc) return null;
    const doc = previewDoc;
    const subtotal = Number(doc.subtotal ?? calculateSubtotal(doc.items ?? []));
    const ivaAmount = Number(doc.ivaAmount ?? calculateIva(subtotal, doc.ivaRate ?? 21));
    const total = Number(doc.total ?? calculateTotal(subtotal, ivaAmount));

    const paymentInfo = (() => {
      if (doc.paymentMethod === 'Transferencia') {
        return { tipo: 'Transferencia Bancaria', banco: 'Caixa Bank', cuenta: 'IBAN:ES26 2100 0686 3702 0051 1108' };
      }
      if (doc.paymentMethod === 'Efectivo') return { tipo: 'Efectivo', banco: '', cuenta: '' };
      if (doc.paymentMethod === 'Tarjeta') return { tipo: 'Tarjeta', banco: '', cuenta: '' };
      return null;
    })();

    return (
      <div className="modal d-block" tabIndex="-1">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{previewDoc?.title || ''}</h5>
              <button type="button" className="btn-close" onClick={closePreview}></button>
            </div>
            <div className="modal-body">
              <div ref={componentRef}>
                <style>{`
                  @page { size: A4; margin: 20mm; }
                  .invoice-wrap { font-family: Arial, Helvetica, sans-serif; color: #111; }
                  .inv-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:18px; }
                  .inv-company { line-height:1; }
                  .inv-company h2 { margin:0; color:#0d6efd; }
                  .inv-title { text-align:right; }
                  .inv-title h3 { margin:0; }
                  .inv-table { width:100%; border-collapse: collapse; margin-top:18px; }
                  .inv-table th { background:#f8f9fa; padding:8px; border-bottom:1px solid #ddd; text-align:left; }
                  .inv-table td { padding:8px; border-bottom:1px solid #eee; vertical-align:top; }
                  .totals { margin-top:12px; width:100%; }
                  .totals .row { display:flex; justify-content:flex-end; gap:10px; }
                  .rgpd { margin-top:18px; font-size:11px; color:#666; border-top:1px solid #eee; padding-top:8px; }
                  .payment { background:#f8f9fa; padding:10px; border-radius:6px; margin-top:10px; }
                `}</style>

                <div className="invoice-wrap">
                  <div className="inv-header">
                    <div className="inv-company">
                      <img src={logoBase64} alt="logo" style={{ width: 160, height: 'auto' }} />
                      <div style={{ marginTop: 6 }}>
                        <div style={{ fontSize: 17, fontWeight: 700 }}>{companyDetails.name}</div>
						<div style={{ fontSize: 14, color: '#555' }}>NIF: {companyDetails.nif}</div>
						<div style={{ fontSize: 14, color: '#555' }}>{companyDetails.address}</div>
						<div style={{ fontSize: 14, color: '#555' }}>{companyDetails.postcode_city} — {companyDetails.province}</div>
						<div style={{ fontSize: 14, color: '#555' }}>T: {companyDetails.phone} — {companyDetails.email}</div>
                      </div>
                    </div>
                    <div className="inv-title">
					  <h3 style={{ color: '#111' }}>{doc.title || ''}</h3>
					  <div style={{ color: '#666', marginTop: 4 }}>{previewType === 'budget' ? 'Presupuesto' : 'Factura'}</div>
					  <div style={{ color: '#666', marginTop: 8 }}>Fecha: {doc.date}</div>
					</div>
                  </div>

                  <div style={{
					  display: 'flex',
					  justifyContent: 'space-between',
					  gap: 12,
					  border: '1px solid #ccc',
					  padding: '8px',
					  borderRadius: '6px',
					  fontSize: '12px',
					  backgroundColor: '#fafafa'
					}}>
					  <div>
						<div style={{ fontWeight: 700, fontSize: '13px' }}>Cliente</div>
						<div>{doc.clientName}</div>
						<div style={{ color: '#666' }}>{doc.clientData?.address}</div>
						<div style={{ color: '#666' }}>{doc.clientData?.city} — {doc.clientData?.province}</div>
						<div style={{ color: '#666' }}>T: {doc.clientData?.phone} — DNI: {doc.clientData?.dni}</div>
					  </div>
					  <div style={{ textAlign: 'right' }}>
						<div style={{ fontWeight: 700, fontSize: '13px' }}>Vehículo</div>
						<div>{doc.vehicleData?.brand} {doc.vehicleData?.model}</div>
						<div style={{ color: '#666' }}>Matricula: {doc.vehicleData?.registration}</div>
						<div style={{ color: '#666' }}>KM: {doc.vehicleData?.km} — VIN: {doc.vehicleData?.vin}</div>
					  </div>
				  </div>

                  <table className="inv-table" style={{ marginTop: 16 }}>
                    <thead>
                      <tr>
                        <th style={{ width: '55%' }}>Material</th>
                        <th style={{ width: '15%', textAlign: 'right' }}>Cantidad</th>
                        <th style={{ width: '15%', textAlign: 'right' }}>Precio unitario</th>
                        <th style={{ width: '15%', textAlign: 'right' }}>Importe</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(doc.items || []).map((it, i) => (
                        <tr key={i}>
                          <td>{it.description}</td>
                          <td style={{ textAlign: 'right' }}>{Number(it.quantity).toFixed(2).replace('.00', '')}</td>
                          <td style={{ textAlign: 'right' }}>{Number(it.unitPrice).toFixed(2)} €</td>
                          <td style={{ textAlign: 'right' }}>{Number(it.total ?? (it.quantity * it.unitPrice)).toFixed(2)} €</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div style={{
					  marginTop: 12,
					  backgroundColor: '#f8f9fa',
					  padding: '8px',
					  borderRadius: '6px'
					}}>
					  <div style={{ fontWeight: 700, fontSize: '13px' }}>Notas</div>
					  <div style={{ color: '#333', fontSize: '12px' }}>{doc.notes || '-'}</div>
				  </div>

                  <div className="payment" style={{ marginTop: 12, fontSize: 12 }}>
                    <div style={{ fontWeight: 700, marginBottom: 4 }}>Método de pago:</div>
					<div style={{ fontSize: '12px', color: '#555' }}>
					  {paymentInfo.tipo}
					  {paymentInfo.banco ? ` — ${paymentInfo.banco}` : ''}
					  {paymentInfo.cuenta ? ` — ${paymentInfo.cuenta}` : ''}
					</div>
                  </div>

                  <div className="totals" style={{ marginTop: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <div style={{ width: 300 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                          <div>Subtotal</div><div>{subtotal.toFixed(2)} €</div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                          <div>IVA ({doc.ivaRate ?? 21}%)</div><div>{ivaAmount.toFixed(2)} €</div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', background: '#f8f9fa', fontWeight: 700 }}>
                          <div>Total</div><div>{total.toFixed(2)} €</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="rgpd">
                    De conformidad con la normativa europea RGPD, Razón Social le informa que sus datos serán tratados para la emisión de facturas y la gestión contable y fiscal durante y como consecuencia de la relación comercial. Sus datos se podrán comunicar a terceros. Puede ejercer sus derechos de acceso, rectificación, supresión, oposición y limitación de tratamiento en tallermovilmenorca@gmail.com únicamente para el cumplimiento de obligaciones legales.
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <div className="me-auto">
                <button className="btn btn-outline-secondary" onClick={closePreview}>Cerrar</button>
              </div>
              <div>
                <button className="btn btn-primary me-2" onClick={handleExportPDF}>
				  <i className="bi-file-earmark-pdf me-2"></i>Guardar PDF</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Delete modal
  const renderDeleteModal = () => {
    if (!showDeleteModal || !docToDelete) return null;
    const label = docToDelete.type === 'client' ? 'cliente' : docToDelete.type === 'article' ? 'artículo' : docToDelete.type === 'budget' ? 'presupuesto' : 'factura';
    return (
      <div className="modal d-block" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">Confirmar eliminación</h5><button className="btn-close" onClick={() => setShowDeleteModal(false)}></button></div>
            <div className="modal-body">¿Estás seguro de que deseas eliminar este {label}? Esta acción no se puede deshacer.</div>
            <div className="modal-footer"><button className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</button><button className="btn btn-danger" onClick={handleDeleteGeneric}>Eliminar</button></div>
          </div>
        </div>
      </div>
    );
  };

// --- Main render ---
  return (
    <>
      {!isLoggedIn ? (
        // --- PANTALLA LOGIN ---
        <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
          <div className="card shadow p-4" style={{ minWidth: 320 }}>
            <h5 className="mb-3 text-center">Iniciar Sesión</h5>
            {loginError && <div className="alert alert-danger py-2">{loginError}</div>}
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label">Usuario</label>
                <input
                  type="text"
                  className="form-control"
                  value={loginUser}
                  onChange={(e) => setLoginUser(e.target.value)}
                  autoFocus
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Contraseña</label>
                <input
                  type="password"
                  className="form-control"
                  value={loginPass}
                  onChange={(e) => setLoginPass(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100">Entrar</button>
            </form>
          </div>
        </div>
      ) : (
        // --- PANTALLA PRINCIPAL DE LA APP ---
        <div>
          {/* Render principal */}
          <div className="container-fluid">
            <ul className="nav nav-tabs mt-3">
              <li className="nav-item">
                <button className={`nav-link ${activeTab === 'budgets' ? 'active' : ''}`} onClick={() => setActiveTab('budgets')}>Presupuestos</button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${activeTab === 'invoices' ? 'active' : ''}`} onClick={() => setActiveTab('invoices')}>Facturas</button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${activeTab === 'clients' ? 'active' : ''}`} onClick={() => setActiveTab('clients')}>Clientes</button>
              </li>
              <li className="nav-item">
                <button className={`nav-link ${activeTab === 'articles' ? 'active' : ''}`} onClick={() => setActiveTab('articles')}>Artículos</button>
              </li>
            </ul>
          </div>

          {showForm && formType === 'budget' && renderDocForm()}
          {showForm && formType === 'invoice' && renderDocForm()}
          {showForm && formType === 'client' && renderClientForm()}
          {showForm && formType === 'article' && renderArticleForm()}

          {!showForm && renderContent()}
          {renderPreviewModal()}
          {renderDeleteModal()}
        </div>
      )}
    </>
  );
}